import type { Store } from "@/lib/store";
import type { CommandArg, CommandResult } from "@/lib/types";

export abstract class Command {
  public abstract name: string;
  public abstract description: string;
  public abstract args: CommandArg[];

  public getUsage(): string {
    const argsStr = this.args
      .map((a) => (a.optional ? `[${a.name}]` : `<${a.name}>`))
      .join(" ");

    const prefix = argsStr ? `${this.name} ${argsStr}` : this.name;
    return `${prefix} - ${this.description}`;
  }

  public abstract execute(args: string[], store: Store): CommandResult;
}
